import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import { getAllCases } from '../../../redux/api/cases';
import { CPDEscalateCases } from '../../../redux/api/workflows';

const AllCases = ({ user }) => {
    const [processing, setProcessing] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [searches, setSearches] = useState({});

    const init = async (start = 0, length = user.paginationSize) => {
        try {
            setProcessing(true);
            const res = await getAllCases({ start, length, searches });
            setRecords(records?.length < start ? res?.resultObject?.data || [] : records.concat(res?.resultObject?.data || []));
            setPaginationData({
                start,
                length,
                total: res?.resultObject?.recordsTotal,
                totalFiltered: res?.resultObject?.recordsFiltered,
            });
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const search = async ({ start, length, ...searches }) => {
        try {
            const res = await getAllCases({ start, length, searches });
            setSearches(searches);
            if (res?.statusCode == '000') {
                setRecords(res?.resultObject?.data || []);
                if (res?.resultObject?.data?.length == 0) {
                    enqueueSnackbar('No result found for search parameters', {
                        variant: 'error',
                    });
                }
            } else {
                enqueueSnackbar(res?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const exportData = async () => {
        try {
            const resp = await getAllCases({ searches }, true);
            enqueueSnackbar(resp?.message || 'Your report is being processed, kindly check the reports page for progress');
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        init();
    }, [user.paginationSize]);

    return (
        <PageContainer pageTitle="All Cases" processing={processing}>
            <CaseTable
                cases={records}
                showCustomFooter={true}
                selectable={true}
                showEscalateCaseBtn
                showDeEscalateCaseBtn={false}
                showCloseCaseBtn={false}
                showResolveCaseBtn={false}
                escalateCaseFunction={CPDEscalateCases}
                initFunction={init}
                exportFunction={exportData}
                searchFunction={search}
                paginationData={paginationData}
            />
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(AllCases);
